import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { PageMeta } from "@models/page";
import { EventCardComponent } from "@shared/components/cards/event-card/event-card.component";
import { SkeletonModule } from "primeng/skeleton";
import { ButtonComponent } from "../../../../../shared/components/button/button.component";
import { EventInfoResponseBody } from "../../../../services/types/events-management-response.type";

enum DISPLAY_SECTION_OPTIONS_ENUM {
  ACTIVES = "actives",
  PAST = "past",
}

@Component({
  selector: "app-my-favorite-events",
  imports: [
    EventCardComponent,
    ButtonComponent,
    SkeletonModule,
    MatButtonToggleModule,
  ],
  templateUrl: "./my-favorite-events.component.html",
  styleUrl: "./my-favorite-events.component.scss",
})
export class MyFavoriteEventsComponent {
  @Input() events: EventInfoResponseBody[] | null = null;
  @Input() meta: PageMeta | null = null;

  @Input() pastEvents: EventInfoResponseBody[] | null = null;
  @Input() pastMeta: PageMeta | null = null;

  @Output() loadMoreActivesClick = new EventEmitter<number>();
  @Output() loadMorePastEventsClick = new EventEmitter<number>();

  DISPLAY_SECTION_OPTIONS_ENUM = DISPLAY_SECTION_OPTIONS_ENUM;
  displaySection = DISPLAY_SECTION_OPTIONS_ENUM.ACTIVES;

  loadMoreActiveEvents() {
    if (!this.meta) {
      return;
    }
    this.loadMoreActivesClick.emit(this.meta?.current_page + 1);
  }

  loadMorePastEvents() {
    if (!this.pastMeta) {
      return;
    }
    this.loadMorePastEventsClick.emit(this.pastMeta?.current_page + 1);
  }
}
